'use client';

import { cva } from 'cva';

import Link from '@/components/link';
import { useFormattedDate } from '@/hooks/use-format-date';
import { usePostContext } from '@/store/context/post';

const linkVariants = cva({
  variants: {
    variant: {
      muted: 'text-muted-foreground hover:text-foreground transition-colors',
    },
  },
});
const editURL = (slug: string) =>
  `https://github.com/tszhong0411/honghong.me/blob/main/apps/web/src/content/blog/${slug}.mdx?plain=1`;

const Footer = () => {
  const { slug, modifiedTime } = usePostContext();
  // const t = useTranslations();

  const formattedDate = useFormattedDate(modifiedTime);

  return (
    <div className="my-8 flex w-full items-center justify-between py-4 text-sm">
      <Link href={editURL(String(slug))} className={linkVariants({ variant: 'muted' })}>
        {'Edit this page on GitHub'}
      </Link>
      <div className="text-muted-foreground">
        {'Last Updated: ' + formattedDate}
      </div>
    </div>
  );
};

export default Footer;
